
import CustomDrawer from './CustomDrawer.vue';
import CloseIcon from '../icons/CloseIcon.vue';
import { mapActions, mapGetters, mapMutations } from 'vuex';

export default {
  name: 'HomePageGuideDrawer',
  components: { CustomDrawer, CloseIcon },
  data() {
    return {
      show: false,
      currentSlide: 1,
      slideCount: 5,
      currentDisplayLanguage: this.$i18n.locale,
    };
  },
  computed: {
    ...mapGetters('authentication', ['profile']),
    bodyText() {
      return this.$t(`home_guide_drawer_slide_${this.currentSlide}`);
    },
    imgUrl() {
      return require(`@/assets/img/new-home-page-guide-drawer-illustration-${this.currentDisplayLanguage}${this.currentSlide}.png`);
    },
    shouldShowBackButton() {
      return this.currentSlide > 1;
    },
    shouldShowOkButton() {
      return this.currentSlide === this.slideCount;
    },
  },
  mounted() {
    this.show = true;

    if (!this.profile.hasSeenHomeGuideDrawer) {
      this.setHomeGuideDrawerSeen().then(() => {
        this.SET_SEEN_HOME_GUIDE_DRAWER();
      });
    }
  },
  methods: {
    ...mapActions('modals', ['toggleHomePageGuideDrawer']),
    ...mapActions('api', ['setHomeGuideDrawerSeen']),
    ...mapMutations('authentication', ['SET_SEEN_HOME_GUIDE_DRAWER']),
    handleBack() {
      this.currentSlide = this.currentSlide - 1;
    },
    handleNext() {
      this.currentSlide = this.currentSlide + 1;
    },
    handleCloseDrawer() {
      this.show = false;
      setTimeout(() => {
        this.toggleHomePageGuideDrawer(false);
        this.$emit('closeDrawer');
      }, 100);
    },
    handleClose() {
      this.handleCloseDrawer();
    },
  },
};
